import { CATEGORICAL_TAGS } from '@cotera/sdk/core';

export const COLOR_MAP = {
  category:
    'fill-secondary-background text-white hover:fill-primary-background',
  gray: 'fill-gray-200 text-accent-foreground',
  active: 'fill-primary-background text-alt-text',
  warning: 'text-black',
  warningActive: 'text-black',
};

export const valueToColor = (value: string | null, category: string | null) => {
  switch (value) {
    case 'active': {
      if (category === null) {
        return COLOR_MAP['warningActive'];
      }
      return COLOR_MAP['active'];
    }
    case 'unique':
    case CATEGORICAL_TAGS.discrete:
      return COLOR_MAP['gray'];
    case null:
      return COLOR_MAP['warning'];
    default:
      return COLOR_MAP['category'];
  }
};
